import React from "react";

const services = [
  {
    num: "01",
    title: "Doors & windows",
    copy: "Interior and exterior door installation, window replacements, weather-tight fits, and the trim work that finishes the opening.",
    detail: "Entry doors \u2022 Interior doors \u2022 Windows",
  },
  {
    num: "02",
    title: "Fences & gates",
    copy: "Fence installation and repairs, gate replacements, and practical improvements to the spaces around your home.",
    detail: "New fences \u2022 Repairs \u2022 Gates",
  },
  {
    num: "03",
    title: "Decks & porches",
    copy: "Deck repairs, replacement boards, steps, railings, and selected new deck projects, with scope and scheduling reviewed first.",
    detail: "Decking \u2022 Steps \u2022 Railings",
  },
  {
    num: "04",
    title: "Sheds & outbuildings",
    copy: "New sheds and small outbuildings, plus repairs to existing structures. Sized and sited to fit the property and permitting rules.",
    detail: "New sheds \u2022 Repairs \u2022 Small outbuildings",
  },
  {
    num: "05",
    title: "Finish woodworking",
    copy: "Baseboards, door and window casing, crown molding, built-ins, and custom finish details tailored to the character of your home.",
    detail: "Trim \u2022 Millwork \u2022 Custom details",
  },
  {
    num: "06",
    title: "Painting",
    copy: "Interior and exterior painting as part of a carpentry project, or as its own scope. Prep, priming, and clean finish coats.",
    detail: "Interior \u2022 Exterior \u2022 Prep & finish",
  },
  {
    num: "07",
    title: "Core drilling",
    copy: "Clean, straight core-drilled openings in concrete or masonry for vents, plumbing, dryer lines, and utility runs.",
    detail: "Concrete \u2022 Masonry \u2022 Utility openings",
  },
  {
    num: "08",
    title: "Concrete slabs",
    copy: "Small concrete slab work for sheds, patios, pads, and steps. Form, pour, and finish scoped to the project.",
    detail: "Shed pads \u2022 Patios \u2022 Steps",
  },
  {
    num: "09",
    title: "Small remodels & project lists",
    copy: "Well-defined remodeling projects, room updates, and lists of related repairs handled together for one clear schedule.",
    detail: "Room updates \u2022 Combined lists \u2022 Select renovations",
  },
];

export default function Services() {
  return (
    <section className="section" id="services" aria-labelledby="services-title">
      <div className="wrap">
        <div className="section-head">
          <div>
            <span className="eyebrow">What we do</span>
            <h2 id="services-title">Make room for<br />the projects on your list.</h2>
          </div>
          <p>Carpentry and home improvements from finish trim to fences, decks, sheds, painting, core drilling, and concrete slabs.</p>
        </div>
        <div className="services-grid">
          {services.map((s) => (
            <article className="service" key={s.num}>
              <span className="num">{s.num}</span>
              <h3>{s.title}</h3>
              <p>{s.copy}</p>
              <p className="detail">{s.detail}</p>
            </article>
          ))}
        </div>
        <p className="scope-note">
          <strong>Scope note:</strong> Every project is reviewed for fit, access, materials, permitting needs, and scheduling before work is agreed. <strong>Not offered:</strong> full-house framing, new-home construction, or whole-structure builds. This is scheduled project work, not an emergency repair service.
        </p>
      </div>
    </section>
  );
}
